import { Typography } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import * as React from "react";

interface LSResultItemSeriesProps {
  resource: ResourceDWR | ResourceView;
}

export const LSResultItemSeries: React.FC<LSResultItemSeriesProps> = ({
  resource,
}) => {
  const { translate } = useLanguage();

  if (!resource?.mainSeries) {
    return null;
  }

  return (
    <Typography variant="subtitle2">
      {translate("series")}: {resource?.mainSeries} {resource?.mainSeriesSubv}
    </Typography>
  );
};
